import { useRef, useState } from 'react';
import * as XLSX from 'xlsx';
import styles from './Excel.module.scss';
import { Text } from '../typography';
import Icon from '../Icon';
import Button from '../Button';

export default function ExcelImport({ onSubmit, file, setFile, onLoading }) {
  const inputRef = useRef();
  const [dragActive, setDragActive] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };
  const handleButtonClick = () => {
    if (inputRef.current) inputRef.current.click();
  };

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      handleFile(e.target.files[0]);
    }
  };

  const handleFile = (file) => {
    onLoading();
    setFile(file);
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet);

      for (const row of rows) {
        onSubmit({ row });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div
      className={styles.container}
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
      onClick={() => {
        if (inputRef?.current) {
          inputRef.current.click();
        }
      }}
      tabIndex={0}
      role="button"
    >
      {!file ? (
        <div className={styles.button}>
          <Icon sx={{ fontSize: '3rem' }} className={styles.icon}>
            photo_camera
          </Icon>
          <Text noMargin weight="semiBold">
            Drag and drop files to upload
          </Text>
          <Button
            className={styles.button}
            variant="secondary"
            size="sm"
            outlined
            value="Select File"
            onClick={handleButtonClick}
            type="button"
          />
          <input
            disabled={dragActive}
            ref={inputRef}
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            style={{ display: 'none' }}
          />
        </div>
      ) : !!file ? (
        <div className={styles.flexRow}>
          <Text noMargin>{file.name}</Text>
          <Icon style={{ color: 'red' }} onClick={() => setFile(null)}>
            delete
          </Icon>
        </div>
      ) : null}
    </div>
  );
}
